import React from 'react';
import { Check, Circle } from 'lucide-react';
import { bookingProgress } from '../../utils/bookingProgress';

export default function BookingProgress({ status, driver = false, asDriver = false, canRespond = false }) {
  const progress = bookingProgress(status, { driver, asDriver, canRespond });
  return <section aria-label="Booking progress" className="rounded-xl bg-orange-50/70 p-4">
    {!progress.interrupted && <ol className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-3">
      {progress.steps.map((step, index) => <li key={step} aria-current={index === progress.index ? 'step' : undefined} className={`flex items-center gap-2 text-xs ${index <= progress.index ? 'font-semibold text-gray-900' : 'text-gray-500'}`}>
        <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${index <= progress.index ? 'bg-[#FF6B00] text-white' : 'bg-white text-gray-400'}`}>{index < progress.index ? <Check size={14} /> : <Circle size={12} />}</span>{step}
      </li>)}
    </ol>}
    <p className={`text-sm ${progress.interrupted ? 'text-amber-900' : 'text-gray-700'}`}>{progress.message}</p>
  </section>;
}
